import { useEffect } from "react";
import Lenis from "lenis";

// Lenis only runs on devices with mouse/trackpad input. On touch devices the
// native scroll is already silky and Lenis just steals ~50 KB of JS + main-thread
// time we can't afford on a 4G mobile LCP budget.
const SHOULD_SMOOTH =
  typeof window !== "undefined" &&
  window.matchMedia?.("(hover: hover) and (pointer: fine)").matches;

export default function SmoothScroll() {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!SHOULD_SMOOTH) return; // touch devices use native scroll
    const lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => {
      lenis.destroy();
    };
  }, []);
  return null;
}
